import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private backendUrl = '';

  constructor() {
    this.defineBackendUrl();
  }

  getFmsUrl(): string {
    return this.backendUrl + 'fms/';
  }

  getFmsUserSettingsUrl(): string {
    return this.getFmsUrl() + 'user-settings/';
  }

  getPortalUrl(): string {
    return this.backendUrl + 'portal/';
  }

  getExternalDataRoomUrl(): string {
    return this.backendUrl + 'external/data-room/';
  }

  getOnboardingUrl(): string {
    return 'https://onboarding.servc.co.il/Onboarding/demo';
  }

  defineBackendUrl(): void {
    const path = window.location.hostname;
    switch (path) {
      case 'localhost': {
        this.backendUrl = 'http://localhost:5000/api/';
        break;
      }
      case 'www.servc-fms.co.il': {
        this.backendUrl = '/api/';
        break;
      }
      case 'demo.orcainc.com': {
        this.backendUrl = 'https://api.demo.orcainc.com/api/';
        break;
      }
      case 'pre-demo.orcainc.com': {
        this.backendUrl = 'https://api.pre-demo.orcainc.com/api/';
        break;
      }
      case 'staging.orcainc.com': {
        this.backendUrl = 'https://api.staging.orcainc.com/api/';
        break;
      }
      case 'fms.orcainc.com': {
        this.backendUrl = 'https://api.fms.orcainc.com/api/';
        break;
      }
    }
  }
}

export const WEBSITE_PROD_ORCA_SOFTWARE = 'https://www.orcainc.com';
export const WEBSITE_PROD_ORCA = 'https://www.orcainc.com';
export const WEBSITE_PROD_ORCA_PRIVACY_POLICY = 'https://www.orcainc.com/privacy-policy';
export const WEBSITE_PROD_ORCA_TERMS_OF_USE = 'https://www.orcainc.com/terms-of-use';

export const ORCA_HELP_MAIL = 'helpdesk@orcainc.com';
